import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "$utils/useSnackbar";
import ProductForm from "../Products/ProductForm";
import { addProduct, editProduct } from "../../api/productApi";
import { EntreprisesServices } from "$services";
import { snackbarErrorOptions } from "$utils/SnackbarOptions";
import { CacheInvalidationAction } from "$utils/cache";

export function CatalogueProductForm({
  togglePopin,
  companyId,
  setSelectedProduct,
  product,
}: any) {
  const token = localStorage.getItem("access_token");
  const [productError, setProductError] = useState<any>(undefined);
  const [openSnackbarError] = useSnackbar(snackbarErrorOptions);

  const { data: company } = useQuery({
    queryKey: [CacheInvalidationAction.GET_COMPANY_BY_ID, companyId],
    queryFn: () => EntreprisesServices.FetchCompany(token, companyId),
    enabled: !!companyId,
    gcTime: 1000 * 60,
  });

  const onSubmitProductForm = async (productData: any) => {
    const handleRequestError = (error: any) => {
      let msg = error;
      if (msg?.includes("exist")) {
        msg = `Un produit avec la même référence produit existe déjà dans le catalogue${
          company ? ` de ${company?.name}` : ""
        }, veuillez modifier la référence principale ou annuler la création du produit`;
      }
      setProductError(msg);
    };

    // Edit existing product
    if (productData?._id) {
      const id = productData?._id;
      try {
        const res: any = await editProduct(
          token,
          {
            ...productData,
            isReferenced: true,
          },
          id
        );
        if (res?.error) {
          handleRequestError(res.error);
          return;
        }
        togglePopin();
        setSelectedProduct(undefined);
      } catch (err) {
        console.error(err);
        openSnackbarError(
          "Une erreur est survenue lors de l'édition du produit."
        );
      }
      return;
    }

    // Add new product
    try {
      const res: any = await addProduct(token, {
        ...productData,
        isReferenced: true,
      });
      if (res?.error) {
        handleRequestError(res.error);
        return;
      }
      togglePopin();
    } catch (err) {
      console.error(err);
      openSnackbarError("Une erreur est survenue lors de l'ajout du produit.");
    }
  };

  return (
    <ProductForm
      onSubmit={onSubmitProductForm}
      onReset={() => {
        togglePopin();
        setProductError(undefined);
      }}
      company={company}
      product={product}
      productError={productError}
    />
  );
}
